'./Footer.css';

import { useTranslation } from 'react-i18next';

import IconFacebook from '../assets/icons/icon-facebook.svg';
import IconInstagram from '../assets/icons/icon-instagram.svg';
import IconYoutube from '../assets/icons/icon-youtube.svg';

function Footer() {
  const [t] = useTranslation('global');

  return (
    <footer className="flex flex-col sm:flex-row justify-end gap-2 sm:justify-between items-center sm:items-end h-[120px] mt-[-80px] pt-0 pb-5 px-8 bg-gradient-to-b from-transparent via-black/50 to-black">
      <div className="social_icons flex gap-2">
        <a
          href="https://www.facebook.com/share/1GMVkTvhZa/?mibextid=LQQJ4d"
          target="_blank"
        >
          <img
            src={IconFacebook}
            alt="facebook-link"
            aria-label="lien facebook"
            className="w-6"
          />
        </a>
        <a
          href="https://www.instagram.com/acquafortetheatre?igsh=MWNrbmtjeWt2bzRiYQ=="
          target="_blank"
        >
          <img
            src={IconInstagram}
            alt="instagram-link"
            aria-label="lien instagram"
            className="w-6"
          />
        </a>
        <a
          href="https://www.youtube.com/@acquafortetheatre760/featured"
          target="_blank"
        >
          <img
            src={IconYoutube}
            alt="youtube-link"
            aria-label="lien youtube"
            className="w-6"
          />
        </a>
      </div>
      <div className="flex gap-10 text-lg sm:text-xl">
        <a id="foot_accueil" href="./" aria-label="accueil">
          {t('footer.link-accueil')}
        </a>
        <a
          id="foot_don"
          href="https://www.helloasso.com/associations/association-acquaforte-theatre/adhesions/association-acquaforte-theatre"
          aria-label="lien pay pal, faire un don"
        >
          {t('footer.link-don')}
        </a>
      </div>
    </footer>
  );
}

export default Footer;
